// extracted by mini-css-extract-plugin
module.exports = {"title":"ChooseChapter_title__suFeh","list":"ChooseChapter_list__ZN0VA"};